/* ============================================================================
   Modal reutilizável + Confirm (substitui window.confirm).
   Uso do confirm (de qualquer lugar):
     if (await confirm({ title, message, danger: true })) { ... }
   Renderize <ConfirmHost /> uma vez (já incluso no AdminLayout).
   ============================================================================ */
import { useState, useEffect } from 'react';
import { IconX, IconTrash } from './icons';

/* ── Modal genérico ── */
export function Modal({ title, subtitle, onClose, children, actions, maxWidth }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="mg-overlay" onClick={onClose}>
      <div className="mg-modal" style={maxWidth ? { maxWidth } : undefined} onClick={(e) => e.stopPropagation()}>
        {(title || onClose) && (
          <div className="mg-modal-head">
            {title && <h3>{title}</h3>}
            {onClose && (
              <button className="mg-icon-btn" onClick={onClose} aria-label="Fechar"><IconX /></button>
            )}
          </div>
        )}
        {subtitle && <p className="mg-modal-sub">{subtitle}</p>}
        {children}
        {actions && <div className="mg-modal-actions">{actions}</div>}
      </div>
    </div>
  );
}

/* ── Confirm singleton ── */
let openConfirm = null;

export function confirm(options) {
  return new Promise((resolve) => {
    if (!openConfirm) { resolve(false); return; }
    openConfirm({ ...options, resolve });
  });
}

export function ConfirmHost() {
  const [state, setState] = useState(null);

  useEffect(() => {
    openConfirm = setState;
    return () => { openConfirm = null; };
  }, []);

  if (!state) return null;

  const {
    title = 'Confirmar',
    message,
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    danger = false,
    icon = true,
    resolve,
  } = state;

  const close = (value) => { resolve(value); setState(null); };

  return (
    <Modal onClose={() => close(false)}>
      {icon && (
        <div className={`mg-modal-icon${danger ? ' is-danger' : ''}`}>
          <IconTrash />
        </div>
      )}
      <h3 style={{ margin: '0 0 8px', fontSize: 19, fontWeight: 700 }}>{title}</h3>
      {message && <p className="mg-modal-sub" style={{ margin: 0 }}>{message}</p>}
      <div className="mg-modal-actions">
        <button className="mg-btn mg-btn-ghost" onClick={() => close(false)}>{cancelLabel}</button>
        <button
          className={`mg-btn ${danger ? 'mg-btn-danger' : 'mg-btn-primary'}`}
          onClick={() => close(true)}
          autoFocus
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
